import React from "react";
import type { FormikState } from "formik";
import { FieldsMapping } from "./components/fields-mapping/FieldsMapping";
import type { Field, Values } from "./types";

type Props = {
    config: Field[];
    microcopies: unknown;
    withNames?: boolean;
    values?: Partial<Values>;
} & Pick<FormikState<unknown>, "errors" | "touched">;

export const FormBuilder = ({ config, errors, touched, microcopies, withNames, values }: Props) => {
    return (
        <>
            {config.map((field) => (
                <FieldsMapping
                    values={values}
                    key={field}
                    microcopies={microcopies}
                    errors={errors}
                    field={field}
                    touched={touched}
                    withNames={withNames}
                />
            ))}
        </>
    );
};
